import { createMuiTheme } from 'onyx-common/styles'

export default createMuiTheme
